import * as React from "react";
import { observer } from "mobx-react";
import { useStore } from "../../App";
import { Stat, StatLabel, StatNumber, StatHelpText, StatArrow, Box, Flex } from "@chakra-ui/core";

export default observer(function Total() {
  const store = useStore();

  const inc = store.land.totalP >= 0;
  return (
    <Flex alignItems="center">
      <Stat pr={0}>
        <StatLabel>Opgenomen</StatLabel>
        <StatNumber>{store.land.total}</StatNumber>
        <StatHelpText>
          <StatArrow type={inc ? "increase" : "decrease"} color={inc ? "red.400" : "green.400"} />
          {store.land.totalP}%
        </StatHelpText>
      </Stat>
    </Flex>
  );
});
